import $ from 'jquery';
import _ from 'underscore';
import TemplateHtml from '../html/popUp.html';
import BaseView from './baseView';
import { getLogger } from './logging/logger';

const logger = getLogger('PopUp');

export default class PopUp extends BaseView {
	id() {
		return 'popup-overlay';
	}

	get template() {
		return _.template(TemplateHtml);
	}

	initialize(options) {
		logger.log('[initialize]');

		this.scrollIncrement = 250;
		this.options = options;
		Object.assign(this, options);
	}

	open() {
		logger.log('[open]');

		return this.dismissView({ duration: 0 })
			.then(() => {
				if (!this.contentHtml) {
					this.contentHtml = this.template(this.options);
				}
				this.$el.append(this.contentHtml);

				$('body').prepend(this.$el);

				this.$('button').trigger('focus');
				this.listenForScroll();
			})
			.then(() => this.displayView());
	}

	close() {
		logger.log('[close]');

		$(window).off('sn:willmove');

		return this.dismissView().then(() => {
			$(this.$el).remove();
		});
	}

	listenForScroll() {
		logger.log('[listenForScroll]');

		const body = $('body').get(0);
		if (body.contains(this.el)) {
			$(window).one('sn:willmove', this.onScroll.bind(this));
		}
	}

	onScroll(event) {
		const { direction } = event.detail;
		logger.debug('[onScroll]', direction);

		if (direction === 'up') {
			this.scrollUp();
		} else if (direction === 'down') {
			this.scrollDown();
		}
		this.listenForScroll();
	}

	scrollUp() {
		logger.log('[scrollUp]');

		const container = this.$el.find('.popup-content').eq(0) || this.$el;
		const currentScroll = container.scrollTop();
		container.animate({ scrollTop: Math.max(0, currentScroll - this.scrollIncrement) });
	}

	scrollDown() {
		logger.log('[scrollDown]');

		const container = this.$el.find('.popup-content').eq(0) || this.$el;
		const currentScroll = container.scrollTop();
		container.animate({ scrollTop: currentScroll + this.scrollIncrement });
	}
}
